import { jsx as _jsx } from "react/jsx-runtime";
import { STANDARD_SPACING } from "../config.js";
export default function Spacer() {
    return _jsx("div", { className: "pb-" + STANDARD_SPACING });
}
